import React from "react";
import { observer } from "mobx-react";
import { extendObservable } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

@injectIntl
@observer
export default class Relation extends React.Component {
  constructor(props) {
    super(props);

    extendObservable(this, {});
  }

  render() {
    const { intl, note, relation, disabled } = this.props;

    return (
      <div className="note-relations-relation-container">
        <Button
          bsStyle="default"
          className="note-relations-relation-button"
          disabled={disabled}
          onClick={() => note.deleteNoteRelation(relation)}
        >
          x
        </Button>
        {relation.targetCardText}
      </div>
    );
  }
}

Relation.propTypes = {
  note: PropTypes.object.isRequired,
  relation: PropTypes.object.isRequired
};
